import { v4 as uuid } from 'uuid';
import {
    getLocationAPI,
} from './api';

function mapClientDetailsToFlags(clientDetails, flags) {
    const { appSource, isWebview, oauthSafe, bundleId, os, browser } = clientDetails;

    flags.webview = isWebview;
    flags.oauthSafe = oauthSafe;
    flags.bundleId = bundleId;
    flags.appSource = appSource;

    // OS
    flags.osName = os;
    flags.ios = os === 'ios';
    flags.android = os === 'android';
    flags.mobile = os === 'ios' || os === 'android';
    flags.mac = os === 'macos';
    flags.windows = os === 'windows';
    flags.chromeos = os === 'chromeos';
    flags.linux = os === 'linux';

    // Browser
    flags.chrome = browser === 'chrome';
    flags.firefox = browser === 'firefox';
    flags.edge = browser === 'edge';
    flags.safari = browser === 'safari';
    flags.ie = browser === 'ie';
    flags.opera = browser === 'opera';
    flags.samsung = browser === 'samsung_internet';

    // App source
    flags.isTwitter = appSource === 'twitter';
    flags.isLinkedIn = appSource === 'linkedin';
    flags.isInstagram = appSource === 'instagram';
    flags.isFacebook = appSource === 'facebook';

    // Use isWebview directly — the API header is the most reliable signal.
    // detectGenericWebview also sets isWebview=true for unrecognised apps,
    // so this covers all in-app cases including ones with appSource='standard_browser'.
    flags.inAppBrowser = isWebview;
}

async function getLocation () {
    const env = this.env;
    const apiKey = this.widgetSettings.apikey;

    const res = await getLocationAPI({
        apiKey,
        traceId: env.traceId,
        store: this,
    });
    this.location = res.data;

    if (res.data?.clientDetails) {
        mapClientDetailsToFlags(res.data.clientDetails, env.appStore.flags);
        this.observed.flags = uuid();
    }

    this.observed.location = uuid();
}

export default getLocation;
